import { Link, useSearchParams } from "react-router";
import ProfileDropDown from "./ProfileDropDown";
// import Hospital from "../icons/Hospital";
import { ChartBarIcon, UserGroupIcon } from "@heroicons/react/24/outline";
import ShareModal from "./ShareModal";
import { ShareIcon } from "@heroicons/react/16/solid";
import Drawer from "./Drawer";
import { useMemo } from "react";

import useUser from "@app/zustand/user";
import getRoomName from "@app/utils/get-room-name";
import { RoomType } from "@prisma/client";

export default function NavBar() {
  const me = useUser((state) => state.user!);

  const [searchParams] = useSearchParams();

  const currentRoomId = searchParams.get("qRoomId");
  const currentRoomType = searchParams.get("qRoomType");

  const currentRoomName = useMemo(() => {
    if (currentRoomType === RoomType.SPECIALITE_AND_STATUS_PRO) {
      return getRoomName(me.rooms.find((r) => r.room.id === currentRoomId));
    }
    if (currentRoomType !== RoomType.DIRECT) {
      return getRoomName(me.rooms.find((r) => r.room.roomType === RoomType.ETABLISSEMENT));
    }
    return getRoomName(me.rooms.find((r) => r.room.id === currentRoomId));
  }, [me.rooms, currentRoomId, currentRoomType]);

  return (
    <nav className="left-0 top-0 flex h-12 w-full shrink-0 items-center justify-center border-b border-b-stone-100">
      <div className="flex w-full items-center justify-between px-2 text-sky-800 md:max-w-6xl">
        <div className="mr-auto h-full md:hidden">
          <Drawer />
        </div>
        <h1 className="mr-auto hidden py-2 font-bold md:block md:text-2xl">
          <Link to="/">MedSpot.fr 🩺 {me.etablissement?.includes("CHU") ? "CHU & périph" : me.etablissement}</Link>
        </h1>
        <h2 className="line-clamp-2 max-h-full w-full overflow-hidden px-2 text-xs font-bold md:hidden md:text-xl">
          {currentRoomName}
        </h2>

        <ShareModal>
          <div className="mr-6 flex h-full flex-col items-center justify-around text-xs opacity-50 hover:opacity-100">
            <ShareIcon className="pointer-events-none mb-0.5 h-6 w-6" />
            <span className="hidden md:inline">Partager</span>
          </div>
        </ShareModal>
        {!!me.isMedspotAdmin && (
          <Link
            to="/stats"
            className="mr-6 hidden h-full flex-col items-center justify-around text-xs opacity-50 hover:opacity-100 md:flex"
          >
            <ChartBarIcon className="pointer-events-none mb-0.5 h-6 w-6" />
            Stats
          </Link>
        )}
        <Link
          to="/users"
          className="mr-6 hidden h-full flex-col items-center justify-around text-xs opacity-50 hover:opacity-100 md:flex"
        >
          <UserGroupIcon className="pointer-events-none mb-0.5 h-6 w-6" />
          Membres
        </Link>
        {/* <Link
          to="/"
          className="mr-6 hidden h-full flex-col items-center justify-around text-xs opacity-50 hover:opacity-100 md:flex"
        >
          <Hospital />
          Accueil
        </Link> */}
        <ProfileDropDown />
      </div>
    </nav>
  );
}
